/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BlockquoteBlock } from './BlockquoteBlock'
import {
  instanceOfBlockquoteBlock,
  BlockquoteBlockFromJSON,
  BlockquoteBlockFromJSONTyped,
  BlockquoteBlockToJSON,
} from './BlockquoteBlock'
import type { FrameTextBlock } from './FrameTextBlock'
import {
  instanceOfFrameTextBlock,
  FrameTextBlockFromJSON,
  FrameTextBlockFromJSONTyped,
  FrameTextBlockToJSON,
} from './FrameTextBlock'
import type { MediaBlock } from './MediaBlock'
import {
  instanceOfMediaBlock,
  MediaBlockFromJSON,
  MediaBlockFromJSONTyped,
  MediaBlockToJSON,
} from './MediaBlock'
import type { TableBlock } from './TableBlock'
import {
  instanceOfTableBlock,
  TableBlockFromJSON,
  TableBlockFromJSONTyped,
  TableBlockToJSON,
} from './TableBlock'
import type { TextBlock } from './TextBlock'
import {
  instanceOfTextBlock,
  TextBlockFromJSON,
  TextBlockFromJSONTyped,
  TextBlockToJSON,
} from './TextBlock'

/**
 * @type ContentInner
 *
 * @export
 */
export type ContentInner =
  | BlockquoteBlock
  | FrameTextBlock
  | MediaBlock
  | TableBlock
  | TextBlock

export function ContentInnerFromJSON(json: any): ContentInner {
  return ContentInnerFromJSONTyped(json, false)
}

export function ContentInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ContentInner {
  if (json == null) {
    return json
  }
  if (instanceOfBlockquoteBlock(json)) {
    return BlockquoteBlockFromJSONTyped(json, true)
  }
  if (instanceOfFrameTextBlock(json)) {
    return FrameTextBlockFromJSONTyped(json, true)
  }
  if (instanceOfMediaBlock(json)) {
    return MediaBlockFromJSONTyped(json, true)
  }
  if (instanceOfTableBlock(json)) {
    return TableBlockFromJSONTyped(json, true)
  }
  if (instanceOfTextBlock(json)) {
    return TextBlockFromJSONTyped(json, true)
  }

  return {} as any
}

export function ContentInnerToJSON(value?: ContentInner | null): any {
  if (value == null) {
    return value
  }

  if (instanceOfBlockquoteBlock(value)) {
    return BlockquoteBlockToJSON(value as BlockquoteBlock)
  }
  if (instanceOfFrameTextBlock(value)) {
    return FrameTextBlockToJSON(value as FrameTextBlock)
  }
  if (instanceOfMediaBlock(value)) {
    return MediaBlockToJSON(value as MediaBlock)
  }
  if (instanceOfTableBlock(value)) {
    return TableBlockToJSON(value as TableBlock)
  }
  if (instanceOfTextBlock(value)) {
    return TextBlockToJSON(value as TextBlock)
  }

  return {}
}
